import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { BaseStructuredFormFields } from '@/pages/instruments/new-instrument/fields/base-structured.fields'
import { OptionalStructuredFields } from '@/pages/instruments/new-instrument/fields/structured.optional.fields'
import { ContractTypeField } from '@/pages/instruments/new-instrument/form-fields/ContractTypeFormField'
import { CouponRateAnnualFormField } from '@/pages/instruments/new-instrument/form-fields/CouponRateAnnualFormField'
import { CouponYearlyObservationsFormField } from '@/pages/instruments/new-instrument/form-fields/CouponYearlyObservationsFormField'
import { KnockDownInputLevelFormField } from '@/pages/instruments/new-instrument/form-fields/KnockDownInputLevelFormField'

export interface RangeAccrualFormFieldsProps {}

export const RangeAccrualFormFields: React.FC<RangeAccrualFormFieldsProps> = ({}) => {
  return (
    <div className="grid gap-6 @2xl:grid-cols-2 @2xl:gap-10">
      <BaseStructuredFormFields />
      <div className={'@container flex flex-col gap-6'}>
        <FormFieldRow>
          <CouponRateAnnualFormField />
          <CouponYearlyObservationsFormField />
          <ContractTypeField />
          <KnockDownInputLevelFormField />
        </FormFieldRow>
        <OptionalStructuredFields />
      </div>
    </div>
  )
}
